
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class BodyRegister2 extends Vue {
  @Prop({ default: [] })
  private items!: Array<any>;
}
